export const BatchUploadFileCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Gestione File - Upload',
    path: '/sistema/gestione-batch/gestione-file/upload',
  },
];

export const BatchDownloadFileCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Gestione File - Download',
    path: '/sistema/gestione-batch/gestione-file/download',
  },
];

export const BatchDownloadAnprFileCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Gestione File - Download ANPR',
    path: '/sistema/gestione-batch/gestione-file/download-anpr',
  },
];
